import styled from 'styled-components';

export const Container = styled.div`
	width: 100%;
	height: auto;
	min-height: 590px;
	border-radius: 10px;
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const Logo = styled.div`
	padding: 25px 20px 20px;
	font-weight: 600;
	font-size: 20px;
	line-height: 115%;
	display: flex;
	align-items: center;
	justify-content: center;
	letter-spacing: 0.5px;
	color: #000000;
	background: #f3f2f9;
	border-radius: 5px;
`;

export const Title = styled.div`
	margin: 15px;
	font-weight: 700;
	font-size: 32px;
	line-height: 121%;
	text-align: center;
	letter-spacing: 0.436556px;
	color: #000000;
`;

export const Content = styled.div`
	position: relative;
	width: calc(100% - 40px);
	margin: 0 auto;
	font-weight: 400;
	font-size: 12px;
	line-height: 14px;
	color: #000000;
	background: linear-gradient(77.38deg, #4d46b1 2.2%, #6a1bba 98.78%);
	border-radius: 5px;
`;

export const Image = styled.img`
	width: ${({ width }) => width};
	height: ${({ height }) => height};
	margin-right: 10px;
`;
